"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnquiryFormFields;
(function (EnquiryFormFields) {
    EnquiryFormFields["MARKETING_INFORMATION"] = "root_marketingInformation";
    EnquiryFormFields["LEGAL_DISCLAIMER"] = "root_legalDisclaimer";
    EnquiryFormFields["PRIVACY_POLICY"] = "root_privacyPolicy";
    EnquiryFormFields["TERMS_AND_CONDITION"] = "root_termsAndConditions";
})(EnquiryFormFields = exports.EnquiryFormFields || (exports.EnquiryFormFields = {}));
